"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var date_util_1 = require("./date-util");
var DateRange = /** @class */ (function () {
    function DateRange() {
    }
    DateRange.fromRange = function (range) {
        var dateRange = new DateRange();
        switch (range) {
            case 'day':
                dateRange.startDate = date_util_1.getStartDateToday();
                dateRange.endDate = date_util_1.getEndDateToday();
                break;
            case 'week':
                dateRange.startDate = new Date(date_util_1.getStartDateToday().getTime() - date_util_1.WEEK_IN_MS);
                dateRange.endDate = date_util_1.getEndDateToday();
                break;
            case 'month':
                dateRange.startDate = new Date(date_util_1.getStartDateToday().getTime() - date_util_1.MONTH_IN_MS);
                dateRange.endDate = date_util_1.getEndDateToday();
                break;
            case 'year':
                dateRange.startDate = new Date(date_util_1.getStartDateToday().getTime() - date_util_1.YEAR_IN_MS);
                dateRange.endDate = date_util_1.getEndDateToday();
                break;
        }
        return dateRange;
    };
    return DateRange;
}());
exports.DateRange = DateRange;
exports.NANO_DATE_RANGE_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return DateRangeSelectorComponent; }),
    multi: true
};
var DateRangeSelectorComponent = /** @class */ (function () {
    function DateRangeSelectorComponent() {
        this.onChange = function (_) {
        };
    }
    DateRangeSelectorComponent.prototype.onValueChange = function (value) {
        this.value = value;
        this.onChange(value);
    };
    DateRangeSelectorComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    DateRangeSelectorComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DateRangeSelectorComponent.prototype.registerOnTouched = function () {
        // only to satisfy interface
    };
    DateRangeSelectorComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'nano-date-range-selector',
            template: require('./date-range-selector.component.html'),
            providers: [
                exports.NANO_DATE_RANGE_VALUE_ACCESSOR
            ]
        }),
        tslib_1.__metadata("design:paramtypes", [])
    ], DateRangeSelectorComponent);
    return DateRangeSelectorComponent;
}());
exports.DateRangeSelectorComponent = DateRangeSelectorComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/common/date/date-range-selector.component.ts
// module id = 177
// module chunks = 0